import LOGO from "../images/BallBrothers.png";

export const Team__BallBrothers = {
  name: "Ball Brothers",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#c37b00",
  teamJerseyColor: "#164F9D",

  // Stats
  gamesWon: 0,
  gamesLost: 3,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 55 + 65 + 2,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 38 + 63 + 0,
    },
  ],
};
